export const userAlerts = {
  resolve: {
    default: "Sorry, there was an error resolving this alert"
  }
};
